<template>
  <div class="h5_login">
      <div class="pic_box">
          <img src="../../../../assets/img/h5_login.png" alt="">
      </div>
      <div>
          <van-field class="userAccount"  v-model="userId" :label="$t('other.a1785')" :placeholder="$t('other.a3186')"/>
          <van-field class="userAccount"  v-model="password" type="password" :label="$t('other.a3185')"  :placeholder="$t('other.a1754')"/>
          
      </div>
      <van-button class="btn" type="info" @click="singIn()">{{$t('other.a3187')}}</van-button>
      <div class="registore" @click="toRegister()">{{$t('other.a3188')}}</div>
  </div>
</template>

<script>
import api from '../../../../api/api'
import md5 from 'js-md5';
export default {
data(){
return{
    password:null,
    userId:null,

}
},
created(){

},
methods:{


    toRegister(){
        this.$router.push({
            path:'/mh5/register',
            query:{
            invitationCode:this.$route.query.invitationCode
            }
        })
    },

    singIn(){      
        if(!this.userId || !this.password){
            this.$toast({
                message:this.$t('other.a1710'),
                position:'center'
            });
            return
        }
        let password=JSON.parse(JSON.stringify(this.password)).replace(/\s*/g,"")
        api
        .getLoginIn({
            userId:this.userId.replace(/\s*/g,""),
            password:md5(password+'seller')
        })
        .then(res => {
        if(res.code === 200 ){
        this.$toast.success(this.$t('other.a1711'))
        localStorage.setItem('userInfo',JSON.stringify(res.data))
        setTimeout(() => {
            this.$router.push({
                path:'Detail',
                query:{
                productId:this.$route.query.productId
                }
            })
        },300)
        }else{
            this.$toast({
                message:res.msg,
                position:'center'
            });
        }
        })



       

        


    },

}
}

</script>
<style lang="scss" scoped>

.h5_login{

    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .userAccount{
        margin: 10px 0;
    }

   .pic_box{
       width: 10rem;
       height: 0;
       padding-bottom:10rem;
       overflow: hidden;


       img{
           width: 100%;
       }
   }

   .btn{
       width: 10rem;
       margin-top: 2rem;
   }

   .registore{
       font-size: 0.6rem;
       margin-top: 10px;
       color:#1989fa ;
   }

   /deep/ .van-field__label{
       width:2rem;
       margin-right:0
   }

   /deep/ .van-field{
       border-bottom: 1px solid #eee;
   }

    /deep/ .van-field::after{
       border-bottom: none;
   }

}
</style>